import { FormErrorMessage, FormHelperText } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const SHOW_FROM_SHARE_OF_MAX = 0.9;

export const TextLengthHint = ({ text, max, length = text.length }: { text: string; max: number; length?: number }) => {
  const { t } = useTranslation();
  if (length > max) {
    return <FormErrorMessage>{t("{{count}} characters too many", { count: length - max })}</FormErrorMessage>;
  }
  if (length < max * SHOW_FROM_SHARE_OF_MAX) return null;
  return <FormHelperText>{t("{{count}} / {{max}} characters", { count: length, max })}</FormHelperText>;
};
